import { useTranslation } from 'react-i18next'
import { Switch, Route } from 'react-router'
import { Box } from '@machobear/design-system'
import BaseLayout from '@/features/Settings/Layout/base-layout'
import usePlan from './use-plan'
import PlanSettingsDashboard from './plan-settings-dashboard'
import PlanSettingsPaymentView from './plan-settings-payment-view'
import usePaymentMethods from './use-payment-methods'

const PlanSettings = () => {
  const { t } = useTranslation()
  const { data: card, isLoading: paymentLoading } = usePaymentMethods()
  const { data: plans, isLoading: planLoading } = usePlan()
  const { active, next } = plans

  return (
    <BaseLayout title={t('l.settings.view.plan_settings.title', 'Plan & Billing')}>
      <Box background="bodyWhite" width="full">
        <Switch>
          <Route
            exact
            path="/settings/plan-settings/payment/view"
            render={props => (
              <PlanSettingsPaymentView card={card} isLoading={paymentLoading} {...props} />
            )}
          />
          <Route
            exact
            path="/settings/plan-settings"
            render={props => (
              <PlanSettingsDashboard
                card={card}
                activePlan={active}
                nextPlan={next}
                isLoading={paymentLoading || planLoading}
                {...props}
              />
            )}
          />
        </Switch>
      </Box>
    </BaseLayout>
  )
}

export default PlanSettings
